<template>
  <nav class="bg-gray-800 p-3 text-white flex justify-between items-center">
    <!-- Logo -->
    <router-link to="/">
      <img
        class="object-scale-down h-7"
        alt="Vue logo"
        src="@/assets/logo.png"
      >
    </router-link>
  
    <!-- Navigation Links -->
    <div>
      <router-link
        to="/"
        class="mx-2 hover:text-gray-300 px-4"
      >
        Home
      </router-link>
      <template v-if="isAuthenticated">
        <router-link
          to="/dsa-report"
          class="mx-2 hover:text-gray-300 px-4"
        >
          DSA Report
        </router-link>
        <router-link
          to="/project-management"
          class="mx-2 hover:text-gray-300 px-4"
        >
          Project Management
        </router-link>
        <router-link
          :to="{ name: 'EmployeeDashboard', params: { staffId: 'me' } }"
          class="mx-2 hover:text-gray-300 px-4"
        >
          My Dashboard
        </router-link>
        <router-link
          to="/employee-insights"
          class="mx-2 hover:text-gray-300 px-4"
        >
          Staff Insights
        </router-link>
        <router-link
          to="/help"
          class="mx-2 hover:text-gray-300 px-4"
        >
          Help
        </router-link>
      </template>
      <router-link
        v-else
        to="/help"
        class="mx-2 hover:text-gray-300 px-4"
      >
        Help
      </router-link>
  
      <!-- Auth links -->
      <button
        v-if="!isAuthenticated"
        class="mx-2 hover:text-gray-300 px-4"
        @click="performLogin"
      >
        Login
      </button>
      <button
        v-else
        class="mx-2 hover:text-gray-300 px-4"
        @click="openLogoutDialog"
      >
        Logout
      </button>
  
      <!-- Confirmation Modal -->
      <ConfirmationDialogue
        :show="modals.logout"
        @confirm="performLogout"
        @update:show="updateModal('logout', $event)"
      />
    </div>
  </nav>
</template>
  
  <script setup>
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/pinia/authStore';
import ConfirmationDialogue from '@/DSAReportComponents/ConfirmationDialogue.vue';

const router = useRouter();
const authStore = useAuthStore();
const isAuthenticated = computed(() => authStore.isAuthenticated);

// Methods
const performLogin = () => {
  authStore.login();
};

const performLogout = async () => {
  await authStore.logout();
  router.push({ name: 'Home' });
};

// Modal state
const modals = ref({ logout: false });
const openLogoutDialog = () => {
  modals.value.logout = true;
};
const updateModal = (type, value) => {
  modals.value[type] = value;
};
</script>

  
  <style scoped>
  button {
    background: none;
    border: none;
    cursor: pointer;
  }
  </style>
  
